var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiskIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0H.5C.225 0 0 .225 0 .5v15c0 .275.225.5.5.5h15c.275 0 .5-.225.5-.5v-13L13.5 0zM4 .5h8v4c0 .275-.225.5-.5.5h-7a.501.501 0 01-.5-.5v-4zm10 15H2V9a1 1 0 011-1h10a1 1 0 011 1v6.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 1h2v3H9V1zM4 9h8v1H4V9zM4 11h8v1H4v-1zM4 13h8v1H4v-1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiskIcon);
export default __webpack_public_path__ + "static/media/disk-icon.b20c68e221a8079445a51bcf25a7996f.svg";
export { ForwardRef as ReactComponent };